import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterDetails',
    standalone: false
})
export class FilterDetailsPipe implements PipeTransform {
  transform(details: any[], searchValue: number): any[] {
    if (!details || searchValue == null) {
      return details;
    }
    return details.filter(detail =>
      detail.pendingForSettlement === searchValue ||
      detail.settledAmount === searchValue ||
      detail.readyForSettlement === searchValue
    );
  }
}
